/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { ConcentratorYeast } from "./modelConcentratorYeast";

class ControllerConcentratorYeast extends ControllerModel {
    constructor() {
        super("ControllerConcentratorYeast");

        this.setNewNode = (callback) => {
            let concentratorYeast = new ConcentratorYeast();
            concentratorYeast.decorate(callback);

            this.addNode(concentratorYeast);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let concentratorYeast = new ConcentratorYeast();
            concentratorYeast.copyFrom(node);
            concentratorYeast.decorate(callback);
            this.addNode(concentratorYeast)
        }

        this.getProperties = async (node) => {
            let n = new ConcentratorYeast();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new ConcentratorYeast();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerConcentratorYeast };